export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resetuj"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaznacz wszystko"])}
}